import styled, { keyframes } from "styled-components";
import logoLapiezaBlue from "../../assets/logo-lapieza-blue.webp";
import { palette } from "../../styles/palette";

// Animación de carga
export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingOverlayContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: ${palette.overlayWhite};
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-width: 100vw;

  &::before {
    content: "";
    position: absolute;
    top: 20px;
    left: 20px;
    width: 130px;
    height: 80px;
    background: url(${logoLapiezaBlue}) no-repeat left top;
    background-size: contain;
    opacity: 1;
    pointer-events: none;
    z-index: 5000;
  }
`;

export const LoadingSpinner = styled.div`
  width: 80px;
  height: 80px;
  border: 4px solid ${palette.greenSecond};
  border-top: 4px solid ${palette.orange};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 24px;
`;

export const LoadingText = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${palette.grenTitle};
  text-align: center;
  margin-bottom: 8px;
`;

export const LoadingSubtext = styled.div`
  font-size: 16px;
  color: ${palette.secondaryTextColor};
  text-align: center;
  max-width: 300px;
  line-height: 1.5;
`;
